<div *ngIf="((loading | async)?.loading) || loadingFromParams" id="spinner-container">
  <sdps-spinner *ngIf="!lockModalVersion"
    type="loading"
    is-outline-visible="false"
    class="disable-component"
    show-by-default="true"
    [attr.inert]="makeInert ? '' : null"
  >
  </sdps-spinner>

  <sdps-spinner *ngIf="lockModalVersion"
    type="contained-submission"
    show-by-default="true"
    id="modal-container-submission-spinner"
    modal-icon-name="schwab-safe"
    modal-icon-position="left"
    modal-text="Loading..."
    prevent-scroll="true"
    spinner-container-id="contained-submission-spinner-container"
    [attr.inert]="makeInert ? '' : null"
  >
  </sdps-spinner>
  </div>